import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "../utils/Auth";

// handle the public routes
function PublicRoute({ component: Component, noLogin=false, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        noLogin || !getToken() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/home" }} />
        )
      }
    />
  );
}

export default PublicRoute;
